import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-payment-sms',
  templateUrl: './payment-sms.component.html',
  styleUrl: './payment-sms.component.scss',
  standalone: false,
})
export class PaymentSmsComponent {
  code: any = '';
  constructor(private route: ActivatedRoute) {
    this.code = this.route.snapshot.paramMap.get('code');
    console.log(this.code);
  }
  ngOnInit(): void {
    window.location.assign('https://rzp.io/rzp/' + this.code);
  }
}
